import styled from 'styled-components';
import { Theme } from '@veneer/theme';
import { Button } from '@veneer/core';

export const StyledDivider = styled.hr<{ $veneerTheme: Theme }>`
  border: none;
  border-top: 1px solid ${({ $veneerTheme }) => $veneerTheme.color.gray3};
  margin: (
    ${({ $veneerTheme }) => $veneerTheme.layout.size4}
      ${({ $veneerTheme }) => $veneerTheme.layout.size2}
  );
  width: 100%;
`;

export const PlainButton = styled(Button)<{ $veneerTheme: Theme }>`
  > span {
    text-align: left;
    white-space: normal;
  }
  &&:focus {
    outline-offset: ${({ $veneerTheme }) => $veneerTheme.layout.size1};
  }
  && {
    padding: 0;
  }
  &&:hover,
  &&:focus,
  &&:active {
    background: none;
  }
`;
